import { baseUrls, apiUrls } from "../../../utils/Endpoints.config";
import { getAxiosConfig, getFomatedError, setFormatedResponse } from "../services/apiService";

/* Add Designation Service*/
const bulkUpload = (params) => {
  const dataParam ={type:'upload'}
  const { axiosInstance, config } = getAxiosConfig(dataParam);
  const response = axiosInstance({
    url: `${baseUrls.main}/${apiUrls.bulkUpload.bulkUploadEmployeeDetails}`,
    method: "POST",
    data: params,
    headers: config.headers || null,
    mode: "no-cors",
  })
    .then((res) => {
      return setFormatedResponse(res);
    })
    .catch((error) => {
      return getFomatedError(error);
    });
  return response;
};


/* Add Designation Service*/
const downloadBulkUploadSampleFile = (params) => {
  const dataParam ={type:'download'}
  const { axiosInstance, config } = getAxiosConfig(dataParam);
  const response = axiosInstance({
    url: `${baseUrls.main}/${apiUrls.bulkUpload.downloadBulkUploadSampleFileRequest}`,
    method: "GET",
    params: params,
    headers: config.headers || null,
    mode: "no-cors",
  })
    .then((res) => {
      return setFormatedResponse(res);
    })
    .catch((error) => {
      return getFomatedError(error);
    });
  return response;
};


export default {
  bulkUpload,
  downloadBulkUploadSampleFile
}